import { useContext } from 'react'
import AssignmentPicker from 'Components/reusable/InputFields/AssignmentPicker'
import { IAssignment } from 'types/assignmentInterfaces'
import { AssignmentId } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextAssignmentField = <T extends AnyObject>({
  field,
  dataField,
  assignmentOptions,
  insetLabel,
  ...rest
}: {
  field: EditableFieldsOfType<T, AssignmentId | null>
  dataField: EditableFieldsOfType<T, IAssignment | null>
  assignmentOptions: IAssignment[]
  insetLabel?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: IAssignment | null) => {
    setFields({ [field]: newValue?.id ?? null, [dataField]: newValue })
  }

  const dataValue = flatData[dataField] as unknown as IAssignment

  return (
    <AssignmentPicker
      onChange={handleChange}
      disabled={disabled[field] ?? false}
      value={dataValue ?? null}
      label={t(`${localeBase}.${field}`)}
      assignmentOptions={assignmentOptions}
      insetLabel={insetLabel}
      {...rest}
    />
  )
}

/**
 * Language picker.
 */
